import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SubscriptionService } from '../../../services/subscription.service';
import { AtabexDataService } from '../../../services/atabex-data.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { responseIsSuccess, onPhoneNumberEntered } from '../../../shared/helper-functions';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { whitespaceValidator } from '../../../shared/whitespace-validator';
import { subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-add-new-billing-address',
  templateUrl: './add-new-billing-address.component.html',
  styleUrls: ['../../../app.component.css']  
})
export class AddNewBillingAddressComponent implements OnInit {
  // Static Data
  subscriptionView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  onPhoneNumberEntered: any;
  saveBillingAddressCompleted: boolean;
  // Required Fields validation
  emptyRequiredState: boolean;
  invalidPhoneNumber: boolean;
  invalidZipcode: boolean;
  // User data
  newBillingAddressForm: FormGroup;
  state: any;
  country:string;

  constructor(public formBuilder: FormBuilder, public subscriptionService: SubscriptionService, public atabexDataService: AtabexDataService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.subscriptionView = subscriptionViewSpanish;
    this.openModal = openModal;
    this.closeModal = closeModal; 
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
    this.onPhoneNumberEntered = onPhoneNumberEntered; 
  }

  ngOnInit() {
    this.saveBillingAddressCompleted = true;
    this.newBillingAddressForm = this.formBuilder.group({
      name: ['', [whitespaceValidator]],
      lastName: ['', [whitespaceValidator]],
      address1: ['', [Validators.required, whitespaceValidator]],
      address2: ['', [whitespaceValidator]],
      city: ['', [Validators.required, whitespaceValidator]],
      zipcode: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]]
    });
  }

  /*
   * Validate required fields in billing address object
   * Validate length of zipcode and phone number (format is being checked in the html file)
  */
  validateFields() {
    this.emptyRequiredState = false;
    // Billing address required fields validation (fields that are not part of newBillingAddressForm and therefore they don't have an Angular validator)
    if (!this.state || !this.country) {
      this.emptyRequiredState = true;
    }
    // Zipcode and phone number validation
    this.phoneNumber && this.phoneNumber.value.length < 14 ? this.invalidPhoneNumber = true : this.invalidPhoneNumber = false;
    this.zipcode && this.zipcode.value.length < 5 ? this.invalidZipcode = true : this.invalidZipcode = false;
  }

  /*
   * Create new billing address
  */
  addBillingAddress() {
    this.validateFields();
    if (!this.emptyRequiredState && !this.invalidZipcode && !this.invalidPhoneNumber) {
      this.saveBillingAddressCompleted = false;
      const payload = {
        CustID: this.subscriptionService.customerId,
        AddressLine1: this.address1.value,
        AddressLine2: this.address2.value,
        City: this.city.value,
        StateID: this.state['StateID'],
        Country: this.country,
        ZipCode: this.zipcode.value,
        PhoneNumber: this.phoneNumber.value
      };
      this.subscriptionService.createBillingAddress(payload).subscribe(
        (response) => {
          if (responseIsSuccess(response)) {
            this.saveBillingAddressCompleted = true;
            this.subscriptionService.toggleAddBillingAddressForm = false;
          }
        },
        (error) => {
          this.saveBillingAddressCompleted = true;
          this.openModal('#errorModal');
        });
    }
  }

  onStateSelected(state) {
    this.state = state;
    state['StateID']=== 'PR' ? this.country = 'Puerto Rico' : this.country = 'Estados Unidos';
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  get name() { return this.newBillingAddressForm.get('name'); }
  get lastName() { return this.newBillingAddressForm.get('lastName'); }
  get address1() { return this.newBillingAddressForm.get('address1'); }
  get address2() { return this.newBillingAddressForm.get('address2'); }
  get city() { return this.newBillingAddressForm.get('city'); }
  get zipcode() { return this.newBillingAddressForm.get('zipcode'); }
  get phoneNumber() { return this.newBillingAddressForm.get('phoneNumber'); }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/add-new-billing-address/add-new-billing-address.component.ts